import { AppSidebar } from "@/features/app-sidebar";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { RequireSession } from "../../components/RequireSession";
import { SidebarInset, SidebarProvider } from "../../components/ui/sidebar";
import { AppSidebarHeader } from "../../features/app-sidebar-header";
import { isomorphicHttpClient } from "../../httpClient";
import { deleteSessionCookie } from "../../utils/session";

const DashboardLayout = () => {
  return (
    <>
      <SidebarProvider>
        <AppSidebar />

        <SidebarInset className="relative mx-auto flex h-full flex-col overflow-auto px-4 md:px-10">
          <AppSidebarHeader />
          <Outlet />
        </SidebarInset>
      </SidebarProvider>

      <RequireSession />
    </>
  );
};

export const Route = createFileRoute("/dashboard")({
  component: DashboardLayout,
  beforeLoad: async ({ context: { queryClient } }) => {
    try {
      const session = await queryClient.fetchQuery({
        queryKey: ["me"],
        queryFn: async () => {
          const httpClient = isomorphicHttpClient();

          const { data, error } = await httpClient.GET("/v1/users/me");
          if (error) {
            if (error.statusCode === 401) {
              await deleteSessionCookie();

              throw new Error("Unauthorized");
            }

            throw new Error(error.message);
          }

          return data;
        },
      });

      if (session.role === "NONE") {
        throw redirect({ to: "/wait" });
      }

      return { session };
    } catch {
      await deleteSessionCookie();

      throw redirect({ to: "/" });
    }
  },
});
